import { GraphQLClient, gql } from "graphql-request";

export const graphcms = new GraphQLClient(process.env.REACT_APP_API);

const homePageSplider = `
    {
        homepageSpliders(orderBy: slideNumber_DESC) {
            id
            title
            description
            slideImage {
                id
                url
            }
            buttonRequireOrNot
            buttonLink
        }
    }
`;
const homepageAboutUs = `
    query MyQuery {
        aboutUs(where: {id: "cli9jwxi94bvk0bprw9sdbjsb"}) {
            summarizedAboutUs
        }
    }
`;
const aboutUs = `
  query MyQuery {
    aboutUs(where: {id: "cli9jwxi94bvk0bprw9sdbjsb"}) {
      membershipStatistics {
        id
        url
      }
    }
  }
`;

const gallery = `
    query MyQuery {
        galleries(first: 50, orderBy: indexNumber_DESC) {
            id
            indexNumber
            eventCategoryName
            coverPicture {
                id
                url
            }
            pictures {
                id
                url
            }
        }
    }  
`;
const galleryByID = `
    id
    indexNumber
    eventCategoryName
    pictures(first: 300) {
        id
        url
        width
        height
    }
`;
const events = `
  id
  flyerImage {
      id
      url
  }
  caption
  description
  eventDateTime
  finished
  keywords
  venue
  zoomLink
  registrationRequiredOrNot
  registrationLink
  speakers(first: 50) {
      id
      title
      name
      occupation
      speakerImage {
        url
      }
      bio
  }
`;
const prevEvents = `
    query MyQuery {
        events(first: 300, where: {finished: true}, orderBy: eventOrderNumber_DESC) {
            id
            caption
            flyerImage {
                id
                url
            }
            keywords
        }
    }
      
`;
const nextEvents = `
    query MyQuery {
        events(first: 300, where: {finished: false}, orderBy: eventOrderNumber_ASC) {
            id
            caption
            flyerImage {
                id
                url
            }
            keywords
        }
    }
      
`;

export const QUERY_SPLIDER = gql`
  ${homePageSplider}
`;
export const QUERY_HOMEPAGE_ABOUT_US = gql`
  ${homepageAboutUs}
`;
export const QUERY_ABOUT_US = gql`
  ${aboutUs}
`;
export const QUERY_MEMBERS_AC_YR_LIST = gql`
  query MyQuery {
    members(first: 300) {
      academicYear
    }
  }
`;
export const QUERY_MEMBERS_BY_AC_YR = gql`
  query GetMembersByAcademicYear($academicYear: String!) {
    members(
      where: { academicYear: $academicYear }
      orderBy: positionOrderNumber_ASC
    ) {
      id
      title
      name
      image {
        id
        url
      }
      position
      stillInThePosition
    }
  }
`;
export const QUERY_MEMBERS_STILL_POSITION = gql`
  query GetMembersStillInPosition {
    members(
      where: { stillInThePosition: true }
      orderBy: positionOrderNumber_ASC
    ) {
      id
      title
      name
      image {
        id
        url
      }
      position
      stillInThePosition
    }
  }
`;
export const QUERY_GALLERY = gql`
  ${gallery}
`;
export const QUERY_GALLERY_BY_ID = gql`
    query GetGalleryImagesByID($galleryID: ID!){
        galleries(where: {id: $galleryID}) {
            ${galleryByID}
        }
    }
    
`;
export const QUERY_EVENTS = gql`
  ${events}
`;
export const QUERY_EVENT_IDS = gql`
  query GetEventIDs {
    events {
      id
    }
  }
`;
export const QUERY_PREV_EVENTS = gql`
  ${prevEvents}
`;
export const QUERY_NEXT_EVENTS = gql`
  ${nextEvents}
`;
export const QUERY_EVENT_BY_ID = gql`
    query GetEventByID($eventID: ID!) {
        events(where: {id: $eventID}) {
            ${events}
        }
    }
    
`;
export const SEARCH_QUERY = gql`
  query SearchQuery($search: String!) {
    members(where: { _search: $search }) {
      id
      title
      name
      image {
        id
        url
      }
      position
      academicYear
    }
    events(where: { _search: $search }) {
      id
      caption
      description
      keywords
      venue
      flyerImage {
        id
        url
      }
      speakers {
        id
        name
      }
    }
    galleries(where: { _search: $search }) {
      id
      eventCategoryName
      coverPicture {
        id
        url
      }
    }
    speakers(where: { _search: $search }) {
      id
      title
      name
      occupation
      speakerImage {
        id
        url
      }
      bio
      events {
        id
        caption
      }
    }
  }
`;
